import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSostaStyles } from "./useSostaStyles";
import Footer from "./Footer";

export default function LegalPageLayout({ title, subtitle, pageTitle, children }) {
  const [scrolled, setScrolled] = useState(false);
  useSostaStyles();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = pageTitle;
    return () => {
      document.title = "Sosta";
    };
  }, [pageTitle]);

  return (
    <>
      <nav className={`s-nav${scrolled ? " scrolled" : ""}`}>
        <Link to="/" className="s-logo" style={{ textDecoration: "none" }}>
          Sosta<span className="s-logo-dot" />
        </Link>
        <Link to="/" className="s-nav-btn">← Back</Link>
      </nav>

      <div style={{ paddingTop: "5rem" }}>
        <div className="s-policy">
          <div className="s-policy-header">
            <div>
              <h1>{title}</h1>
              {subtitle && <p style={{ fontSize: 13 }}><strong>{subtitle}</strong></p>}
            </div>
            <Link to="/" className="s-close-btn" aria-label="Close">
              <svg className="s-close-icon" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </Link>
          </div>

          {children}

          <Link to="/" className="s-back-btn">Back to Sosta 🩷</Link>
        </div>
      </div>

      <Footer />
    </>
  );
}
